import { Dialog, DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { fromEvent, Observable, Subscription } from 'rxjs';
import { SharedService } from '../../../../../Services/shared.service';
import { ConfirmationDialogComponent } from '../../confirmation-dialog/confirmation-dialog.component';



@Component({
  selector: 'app-dialog-exam-submit',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dialog-exam-submit.component.html',
  styleUrl: './dialog-exam-submit.component.css'
})
export class DialogExamSubmitComponent {
  Object: any;
  Status: any;
  conn: any;

  public onlineEvent: Observable<Event>;
  public offlineEvent: Observable<Event>;
  public subscriptions: Subscription[] = [];
  Message: any = null;


  constructor(
    @Inject(DIALOG_DATA) public data: any,
    private _dialogRef: DialogRef,
    private _dialog: Dialog,
    private _svc: SharedService
  ) {

    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');
    this.subscriptions.push(this.onlineEvent.subscribe(event => {

      this.Message = 'Connected to internet! You are online';
      this.Status = 'online';
      this._svc.Notification("success", this.Message);
      this.CheckNetSpeed();
    }));
    this.subscriptions.push(this.offlineEvent.subscribe(e => {

      this.Message = 'Connection lost! You are offline';
      this.Status = 'offline';
      this._svc.Notification("error", this.Message);

    }));
  }

  IsSave: any;
  ngOnInit(): void {

    this.IsSave = true;
    var dialogOption = this.data;
    this.Message = 'Connected to internet! You are online';
    this.Status = 'online';

    this.conn = {
      NetSpeed: null
    }
    this.Object = {
      QuestionList: dialogOption.questionList,
      NOQ: dialogOption.questionList.length,
      Answered: null
    }

    var _ans = this.Object.QuestionList.filter((x: any) => x.AnsId > 0);
    this.Object.NotAttend = this.Object.QuestionList.filter((x: any) => x.AnsId == null);
    // this.Object.MarkForReview = this.Object.QuestionList.filter((x: any) => x.IsMarkForReview == true);
     this.Object.MarkForReview = this.Object.QuestionList.filter((x: any) => x.IsMarkForReview === true && (!x.AnsId || x.AnsId === 0));
    this.Object.Answered = _ans.length;
    this.Object.Enable_Yes_For_Submit = dialogOption.Enable_Yes_For_Submit;

    this.CheckNetSpeed();
  }

cancel() {
    this._dialog.open(ConfirmationDialogComponent, {
      data: { title: "Confirmation", message: "Do you want to go back? ", btnCancelText: "No", btnOkText: "Yes" }
    }).closed.subscribe((res: any) => {
      
      if (res.result == "Yes") {
        this._dialogRef.close({ result: 'Close' });
      }
    });

  }


  CheckNetSpeed() {
    this._svc.testDownloadSpeed().then(speed => {
      this.conn.NetSpeed = speed;
    }).catch(console.error);

  }

  Copy_To_Clipboard() {
    // Copy_To_Clipboard();
  }

  Next() {
    this._dialog.open(ConfirmationDialogComponent, {
      data: { title: "Confirmation", message: "No changes will be allowed after submission.<br><br>Are you sure you want to submit your test? ", btnCancelText: "No", btnOkText: "Submit Exam" }
    }).closed.subscribe((res: any) => {
      
      if (res.result == "Yes") {
        this._dialogRef.close({ result: 'ExamSubmit' });
      }
    });

  }

  // Finish() {


  // }
}
